import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaTemplatesSystemMail } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetDocumentsDemandedTemplate = schemaTemplatesSystemMail.nullable();

export type SchemaTemplateResolver_GetDocumentsDemandedTemplate = z.infer<
    typeof schemaTemplateResolver_GetDocumentsDemandedTemplate
>;

export type TemplateResolver_GetDocumentsDemandedTemplate = Resolver<
    Arguments,
    SchemaTemplateResolver_GetDocumentsDemandedTemplate
>;
